export const MAIN_TABS = [
  { key: "websiteConversion", label: "Website conversion" },
  { key: "storeFunnel", label: "Store funnel" },
  { key: "pdpRankings", label: "PDP rankings" },
  { key: "pdpDeepDive", label: "PDP deep dive" },
];

export const RANKING_TABS = [
  { key: "activeProducts", label: "Active Products" },
  { key: "topSelling", label: "Top selling" },
  { key: "highestContribution", label: "Highest contribution" },
  { key: "mostOpportunity", label: "Most opportunity" },
  { key: "bestConverting", label: "Best converting" },
  { key: "losingMomentum", label: "PDPs that need attention" },
];
